import { store } from '@hotjar/webapp/tracking/common/tracking-context-store';
import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

import type { OwnedAccount, SiteAccount, Account } from '@hotjar/account';

interface AuthenticationNeededProps {
  billing3DS2Enabled: boolean;
  account: Account | SiteAccount | OwnedAccount;
}

/**
 * User is passing through the payment authentication flow which might result in 3DS2 challenge
 * @param {boolean} billing3DS2Enabled Whether account has 3DS2 enabled
 */
export function authenticationNeeded({
  billing3DS2Enabled = false,
  account,
}: AuthenticationNeededProps): void {
  const { context } = store.getState();

  Segment.track('Payment Method Authentication Flow Started', {
    origin: context?.origin,
    billing3DS2Enabled,
    ...extractAccountGroupingProps(account),
  });
}
